module.exports = __webpack_public_path__ + "img/Pietro.225cb0cf.jpg";